import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'BIAS' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'BIAS', label: 'Bias Ratio', pane: 'sub', params: [6, 12, 24], outputs: ['bias1', 'bias2', 'bias3'], labels: ['Period 1', 'Period 2', 'Period 3'] })
